/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelHIcon16Solid = forwardRef('ArrowParallelHIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M9.35 1.76A1 1 0 1 1 10.65.24l2.67 2.289c.419.36.643.854.673 1.357a1.016 1.016 0 0 1 0 .228c-.03.503-.254.997-.674 1.357l-2.669 2.288A1 1 0 0 1 9.35 6.241L10.797 5H3a1 1 0 1 1 0-2h7.797L9.349 1.76Z" }),
        React.createElement("path", { d: "M6.65 8.76a1 1 0 1 0-1.3-1.52L2.68 9.53c-.42.36-.645.854-.674 1.358a1.009 1.009 0 0 0 0 .226c.03.504.254.998.674 1.358l2.67 2.288a1 1 0 0 0 1.3-1.518L5.204 12H13a1 1 0 1 0 0-2H5.203l1.448-1.242Z" })));
});
